export default __webpack_public_path__ + "static/media/city.ea0ee210.svg";